import styled from '@emotion/styled';
import { Modal } from 'antd';
import { colorConstants } from 'config/colorConstants';

const PURPLE = colorConstants.purpleFont;
const PURPLE_LIGHT_BG = '#F7F5FF';
const BORDER_DEFAULT = '#E4E4E7';
const TEXT_MUTED = '#71717B';
const HOVER_BORDER = '#91CAFF';
const DISABLED_BUTTON_BG = '#F4F4F5';
const DISABLED_BUTTON_TEXT = '#A1A1AA';

export const StyledSaveOnLeaveModal = styled(Modal)`
    .ant-modal-content {
        border-radius: 12px !important;
        padding: 0 !important;
        overflow: hidden;
        box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12),
            0 9px 28px 8px rgba(0, 0, 0, 0.05);
    }

    .ant-modal-body {
        padding: 0 !important;
    }
`;

export const ModalContent = styled.div`
    display: flex;
    flex-direction: column;
    padding: 24px;
    gap: 20px;
`;

export const ModalHeader = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 12px;
`;

export const InfoIconBadge = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: ${PURPLE};
    color: #ffffff;
    font-size: 12px;
    font-weight: 700;
    line-height: 1;
    flex-shrink: 0;
    margin-top: 1px;
`;

export const ModalTitleBlock = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
`;

export const ModalTitle = styled.h2`
    margin: 0;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    color: #18181b;
`;

export const ModalSubtitle = styled.p`
    margin: 0;
    font-size: 14px;
    line-height: 22px;
    color: ${colorConstants.blackAlt};
`;

export const OptionsList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const OptionCard = styled.button<{
    isSelected: boolean;
    isDisabled?: boolean;
}>`
    display: flex;
    align-items: flex-start;
    gap: 12px;
    width: 100%;
    padding: 12px 16px;
    border-radius: 8px;
    border: 1px solid ${({ isSelected }) => (isSelected ? PURPLE : BORDER_DEFAULT)};
    background: ${({ isSelected }) => (isSelected ? PURPLE_LIGHT_BG : '#ffffff')};
    text-align: left;
    cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
    opacity: ${({ isDisabled }) => (isDisabled ? 0.55 : 1)};
    transition:
        border-color 0.15s ease,
        background-color 0.15s ease,
        box-shadow 0.15s ease;

    &:not(:disabled):hover {
        border-color: ${({ isSelected, isDisabled }) =>
            isDisabled ? BORDER_DEFAULT : isSelected ? PURPLE : HOVER_BORDER};
        box-shadow: ${({ isSelected, isDisabled }) =>
            isDisabled || isSelected ? 'none' : 'inset 0 0 0 1px #BAE0FF'};
    }

    &:not(:disabled):focus-visible {
        outline: none;
        border-color: ${({ isSelected }) => (isSelected ? PURPLE : HOVER_BORDER)};
        box-shadow: inset 0 0 0 1px #91caff;
    }
`;

export const OptionRadio = styled.span<{ isSelected: boolean }>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    margin-top: 3px;
    border-radius: 50%;
    border: 1px solid ${({ isSelected }) => (isSelected ? PURPLE : '#D4D4D8')};
    background: #ffffff;
    flex-shrink: 0;

    &::after {
        content: '';
        display: ${({ isSelected }) => (isSelected ? 'block' : 'none')};
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: ${PURPLE};
    }
`;

export const OptionText = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
    flex: 1;
`;

export const OptionTitle = styled.span`
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
    color: ${PURPLE};
`;

export const OptionDescription = styled.span`
    font-size: 14px;
    line-height: 22px;
    color: ${TEXT_MUTED};
    white-space: pre-line;
`;

export const ModalFooter = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-top: 4px;
`;

export const ConfirmFooterButton = styled.button<{ isEnabled: boolean }>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 120px;
    height: 32px;
    padding: 0 16px;
    border-radius: 6px;
    border: 1px solid ${({ isEnabled }) => (isEnabled ? PURPLE : DISABLED_BUTTON_BG)};
    background: ${({ isEnabled }) => (isEnabled ? PURPLE : DISABLED_BUTTON_BG)};
    font-size: 14px;
    line-height: 22px;
    font-weight: 600;
    color: ${({ isEnabled }) => (isEnabled ? '#ffffff' : DISABLED_BUTTON_TEXT)};
    cursor: ${({ isEnabled }) => (isEnabled ? 'pointer' : 'not-allowed')};

    &:not(:disabled):hover {
        opacity: 0.92;
    }
`;
